import { appConfig } from '@ami/react/core';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import EffectiveLeadTimeLabel from './EffectiveLeadTimeLabel';

const QuoteProductLeadTime = ({
  leadTime,
  onLeadTimeViewDetailsClick,
  maskPricingAndLeadTimes,
  quoteProductTotalLeadTimeInDays
}) => {
  return (
    <Fragment>
      {leadTime && (
        <div className="clearfix lead-time-section">
          <span className="leadtime-days">
            {maskPricingAndLeadTimes ? "N/A" :
              <EffectiveLeadTimeLabel
                isFastTrack={leadTime.isFastTrack}
                leadTimeDays={quoteProductTotalLeadTimeInDays ?? leadTime.totalLeadTimeInDays}
                showLeadTimeCalculationSpinner={false}
                availableOn={leadTime.availableOn}
              />
            }
          </span>
        </div>
      )}

      {appConfig.isManagementApp && onLeadTimeViewDetailsClick && (
        <div>
          <button className="btn btn-link p-1 m-0" type="button" onClick={onLeadTimeViewDetailsClick}> view details</button>
        </div>
      )}
    </Fragment>
  );
};

QuoteProductLeadTime.propTypes = {
  leadTime: PropTypes.object,
  onLeadTimeViewDetailsClick: PropTypes.func,
  maskPricingAndLeadTimes: PropTypes.bool,
  quoteProductTotalLeadTimeInDays: PropTypes.number,
};

export default QuoteProductLeadTime;
